
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Sarah Johnson',
      location: 'London to Manchester',
      rating: 5,
      text: 'MGM RELO LTD made our international move from London to New York absolutely seamless. Their team was professional, punctual, and handled our belongings with exceptional care. The fine art handling service was particularly impressive.',
      service: 'International Moving',
      image: 'https://public.readdy.ai/ai/img_res/cd737542ccd6ec09ed41116b4b92d67d.jpg'
    },
    {
      name: 'Michael Chen',
      location: 'Birmingham Relocation',
      rating: 5,
      text: 'Outstanding handyman services! They not only handled our domestic move perfectly but also assembled all our furniture and hung our pictures. The attention to detail and quality of work exceeded our expectations.',
      service: 'Domestic Moving + Handyman',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20businessman%20in%20business%20suit%20smiling%20warmly%2C%20corporate%20headshot%20photography%2C%20professional%20lighting%2C%20confident%20friendly%20demeanor%2C%20modern%20office%20background%2C%20clean%20professional%20appearance&width=150&height=150&seq=testimonial-2&orientation=squarish'
    },
    {
      name: 'Emma Thompson',
      location: 'Edinburgh to London',
      rating: 5,
      text: 'I was nervous about moving my art collection, but MGM RELO LTD\'s fine art handling team was incredible. They used specialized packing and climate-controlled transport. Every piece arrived in perfect condition.',
      service: 'Fine Art Handling',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20middle-aged%20woman%20with%20professional%20appearance%20smiling%20confidently%2C%20art%20gallery%20or%20museum%20background%2C%20sophisticated%20lighting%2C%20cultural%20professional%20setting%2C%20warm%20approachable%20expression&width=150&height=150&seq=testimonial-3&orientation=squarish'
    },
    {
      name: 'David Rodriguez',
      location: 'Glasgow Office Move',
      rating: 5,
      text: 'We hired MGM RELO LTD for our office relocation and they were fantastic. Minimal downtime, professional team, and they even helped set up our new workspace. Highly recommend for business moves.',
      service: 'Commercial Moving',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20businessman%20in%20modern%20office%20environment%2C%20confident%20smile%2C%20business%20casual%20attire%2C%20contemporary%20workplace%20background%2C%20professional%20corporate%20photography%20style&width=150&height=150&seq=testimonial-4&orientation=squarish'
    },
    {
      name: 'Lisa Williams',
      location: 'Local Move in London',
      rating: 5,
      text: 'From start to finish, the service was exceptional. They provided transparent pricing, arrived on time, and the handyman services for curtain installation and picture hanging saved us so much time.',
      service: 'Full Service Package',
      image: 'https://readdy.ai/api/search-image?query=Professional%20woman%20with%20warm%20smile%20in%20contemporary%20home%20setting%2C%20casual%20professional%20attire%2C%20bright%20natural%20lighting%2C%20modern%20residential%20background%2C%20friendly%20approachable%20appearance&width=150&height=150&seq=testimonial-5&orientation=squarish'
    },
    {
      name: 'James Mitchell',
      location: 'Bristol to Cardiff',
      rating: 5,
      text: 'Moving across Wales was stress-free thanks to MGM RELO LTD. Their communication throughout the process was excellent, and the team was incredibly careful with our antique furniture. Will definitely use again.',
      service: 'Domestic Relocation',
      image: 'https://readdy.ai/api/search-image?query=Distinguished%20middle-aged%20man%20in%20professional%20business%20attire%2C%20confident%20friendly%20expression%2C%20modern%20office%20or%20business%20environment%2C%20professional%20lighting%2C%20approachable%20demeanor&width=150&height=150&seq=testimonial-6&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">What Our Customers Say</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers have to say about 
            their experience with MGM RELO LTD's professional services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{testimonial.name}</h3>
                  <p className="text-gray-600 text-sm">{testimonial.location}</p>
                  <div className="flex items-center mt-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                </div>
              </div>
              
              <div className="mb-4">
                <span className="inline-block bg-blue-100 text-blue-800 text-xs font-medium px-3 py-1 rounded-full">
                  {testimonial.service}
                </span>
              </div>
              
              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="inline-flex items-center bg-blue-50 rounded-2xl px-8 py-6">
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">4.9/5</div>
              <div className="flex justify-center mb-2">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <p className="text-gray-600 font-medium">Average Customer Rating</p>
              <p className="text-gray-500 text-sm">Based on 500+ reviews</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
